import { Box, SelectChangeEvent } from '@mui/material';
import { useCallback, useContext, useEffect, useState } from 'react';

import { SelectInput } from '@/components/common/select_input/SelectInput';
import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

function HasSchoolDistrictInput() {
  const [schoolDistrict, setSchoolDistrict] = useState<boolean | null>(null);

  const { partnerInfo, partnerGroupInfo, updatePartnerInfo, updatePartnerGroupInfo, showErrors } =
    useContext(PartnerIntakeContext);

  const handleHasSchoolDistrictChange = useCallback(
    (e: SelectChangeEvent) => {
      const updatedValue = (e.target as HTMLInputElement).value;
      const booleanValue = updatedValue === '1' ? true : updatedValue === '0' ? false : null;

      if (updatePartnerInfo && partnerInfo) {
        updatePartnerInfo({ ...partnerInfo, schoolDistrict: booleanValue });
      }

      if (booleanValue === true) {
        updatePartnerGroupInfo({ ...partnerGroupInfo, partnerName: null });
      }
    },
    [updatePartnerInfo, partnerInfo, updatePartnerGroupInfo, partnerGroupInfo]
  );

  useEffect(() => {
    if (partnerInfo?.schoolDistrict != schoolDistrict)
      setSchoolDistrict(partnerInfo?.schoolDistrict ?? null);
  }, [partnerInfo?.schoolDistrict, schoolDistrict]);

  return (
    <Box flexGrow={1}>
      <SelectInput
        id={'school-district-select'}
        label={'Is your school part of a district?'}
        value={schoolDistrict != null ? (partnerInfo.schoolDistrict ? 1 : 0).toString() : ''}
        hasError={showErrors && schoolDistrict == null}
        selectOptions={[
          { value: '1', label: 'Yes' },
          { value: '0', label: 'No' },
        ]}
        required
        onChange={handleHasSchoolDistrictChange}
      />
    </Box>
  );
}

export default HasSchoolDistrictInput;
